import { Component, OnInit, OnDestroy, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-news-slide',
  templateUrl: './news-slide.component.html',
  styleUrls: ['./news-slide.component.scss']
})
export class NewsSlideComponent implements OnInit, OnDestroy {

  private ngUnsubscribe: Subject<void>; //Permet de grabber tout ce qu'on doit finallement unsubscribe.

  public currentLang: string;
  public nbNouvelles: number;
  public listeNouvelles: any[];
  public posNouvellesStart: number;
  public posNouvellesEnd: number;
  public nouvellesPositionLeft: number;

  constructor(private route: ActivatedRoute, private elementRef: ElementRef,
    private deviceService: DeviceDetectorService,
    private translateService: TranslateService) {
    this.currentLang = this.translateService.currentLang;
    this.listeNouvelles = this.route.snapshot.data.nouvelles;
    this.nbNouvelles = this.listeNouvelles.length || 0;
    this.posNouvellesStart = 0;
    this.posNouvellesEnd = 0;
    this.nouvellesPositionLeft = 0;
    this.ngUnsubscribe = new Subject<void>();
  }

  ngOnInit() {

    this.translateService.onLangChange.pipe(takeUntil(this.ngUnsubscribe)).subscribe((event: LangChangeEvent) => {
      this.currentLang = event.lang
    });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }​​​​​​​​
    
  onSwipe(event) {
    if (this.deviceService.isMobile()) {
      if (event.overallVelocityX > 0) {
        this.prev();
      } else if (event.overallVelocityX < 0) {
        this.next();
      }
    }
  }

  next() {
    const nouvelleWidth: number = this.getNouvelleWidth();

    if (this.posNouvellesEnd < this.nbNouvelles - 1) {
      this.posNouvellesStart++;
      this.posNouvellesEnd++;
      this.nouvellesPositionLeft = this.posNouvellesStart * nouvelleWidth * -1;
    }
  }

  prev () {
    const nouvelleWidth: number = this.getNouvelleWidth();

    if (this.posNouvellesStart > 0) {
      this.posNouvellesStart--;
      this.posNouvellesEnd--;
      this.nouvellesPositionLeft = this.posNouvellesStart * nouvelleWidth * -1;
    }
  }

  private getNouvelleWidth() {
    const nouvellesList = this.elementRef.nativeElement.querySelectorAll('.nouvelles-list') as HTMLElement[];
    const singleNouvelle = this.elementRef.nativeElement.querySelectorAll('.single-nouvelle') as HTMLElement[];
    const nouvellesListWidth: number = nouvellesList[0].offsetWidth;
    const nouvelleWidth: number = singleNouvelle[0].offsetWidth + (this.deviceService.isMobile() ? 40 : 32);
    const nbVisibleNouvelles: number = parseInt(Math.round(nouvellesListWidth / nouvelleWidth) + '', 10);

    this.posNouvellesEnd = this.posNouvellesStart + nbVisibleNouvelles - 1;

    return nouvelleWidth;
  }

}
